export const pages = {
  CONTENT: "CONTENT",
  SETTINGS: "SETTINGS",
  SUBMIT_PHOTO: "SUBMIT_PHOTO",
  TOOLS: "TOOLS",
  SHUNT_CONVERSION: "SHUNT_CONVERSION",
  METRICS_CONVERSION: "METRICS_CONVERSION",
  MAP: "MAP",
};
